import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-7a2daec5"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { calss: "course-detail" };
var _hoisted_2 = { class: "course" };
var _hoisted_3 = { class: "cover" };
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "desc" };
var _hoisted_6 = { class: "price" };
var _hoisted_7 = { class: "current-price" };
var _hoisted_8 = { class: "discount-price" };
var _hoisted_9 = { class: "title" };
var _hoisted_10 = { class: "subtitle" };
var _hoisted_11 = { class: "sub-desc" };
var _hoisted_12 = { class: "tag" };
var _hoisted_13 = { class: "tag-item" };
var _hoisted_14 = { class: "tag-item" };
var _hoisted_15 = { class: "buy" };
var _hoisted_16 = ["src"];
var _hoisted_17 = { class: "meun-section" };
var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
    key: 0,
    class: "course-desc"
};
var _hoisted_20 = ["innerHTML"];
var _hoisted_21 = {
    key: 1,
    class: "course-meun"
};
var _hoisted_22 = { class: "course-meun-tabs" };
var _hoisted_23 = ["onClick"];
var _hoisted_24 = ["onClick"];
var _hoisted_25 = {
    key: 0,
    class: "overlay"
};
var _hoisted_26 = ["src"];
var _hoisted_27 = ["src"];
var _hoisted_28 = { class: "course-meun-item-intro" };
var _hoisted_29 = { class: "title-container" };
var _hoisted_30 = { class: "title" };
var _hoisted_31 = {
    key: 0,
    class: "try-see"
};
var _hoisted_32 = { class: "intro" };
var _hoisted_33 = {
    key: 0,
    class: "intro-item"
};
var _hoisted_34 = ["src"];
var _hoisted_35 = { class: "intro-item" };
var _hoisted_36 = ["src"];
var _hoisted_37 = ["onClick"];
var _hoisted_38 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", null, "资料", -1); });
var _hoisted_39 = ["src"];
var _hoisted_40 = { class: "btn" };
import { getAICourse } from '@/api/course';
import { getParentWXSignature } from '@/api/common';
import { onMounted, ref } from 'vue';
import OpenApp from '@/components/OpenApp/index.vue';
import { registerWxopenButton } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        var _this = this;
        var userAgent = navigator.userAgent;
        // 判断是否在微信中
        // var isInWeChat = /MicroMessenger/.test(userAgent)
        var route = useRoute();
        var router = useRouter();
        var skuId = route.query.skuId;
        var tabs = [
            {
                name: '详情',
                id: 0
            },
            {
                name: '目录',
                id: 1
            }
        ];
        var curTabRef = ref(0);
        var state = ref({
            chapterList: []
        });
        var currentVideo = ref('');
        var currentMediaList = ref([]);
        var chapterIdRef = ref('');
        var openTeachingMaterial = function (record) {
            if (record.payType == 0)
                return;
            window.open(record.teachingMaterial.fileUrl);
        };
        var changeChapter = function (index, id) {
            currentMediaList.value = state.value.chapterList[index].itemList;
            chapterIdRef.value = id;
        };
        var getDuration = function (count) {
            var m = Math.floor(Number(count).toFixed(0) / 60);
            var s = Number(count).toFixed(0) % 60;
            return (m > 10 ? m : '0' + m) + ':' + (s > 10 ? s : '0' + s);
        };
        // 0  视频  2 图文 1 音频
        var mediaType = ref(0);
        var playCourse = function (record) {
            if (record.payType === 0)
                return;
            if (mediaType.value === 0) {
                currentVideo.value = record.video.videoUrl;
            }
            else if (mediaType.value === 2) {
                router.push({
                    path: '/media',
                    query: { id: record.id }
                });
            }
        };
        var changeTabs = function (id) {
            curTabRef.value = id;
        };
        // 获取课程
        var _getAICourse = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAICourse({ skuId: skuId, hasWork: '' })];
                    case 1:
                        data = (_a.sent()).data;
                        state.value = data;
                        mediaType.value = data.mediaType;
                        currentMediaList.value = data.chapterList[0].itemList;
                        chapterIdRef.value = data.chapterList[0].id;
                        return [2 /*return*/];
                }
            });
        }); };
        onMounted(function () {
            _getAICourse();
            registerWxopenButton(getParentWXSignature);
        });
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: state.value.imgCover,
                                alt: ""
                            }, null, 8, _hoisted_4)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(state.value.price), 1),
                                _createElementVNode("div", _hoisted_8, "原价：¥" + _toDisplayString(state.value.markingPrice), 1)
                            ]),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(state.value.name), 1),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(state.value.simpleDescription), 1),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(state.value.suitAge) + "岁", 1),
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(state.value.chapterList.length) + "讲", 1)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("img", {
                                        src: require('@/pages/Course/assets/learn_count.png'),
                                        alt: ""
                                    }, null, 8, _hoisted_16),
                                    _createElementVNode("div", null, _toDisplayString(state.value.courseCount) + "人学过", 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                            class: "tabs",
                            style: _normalizeStyle({ top: currentVideo.value ? '210px' : '0px' })
                        }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, function (item) {
                                return _createElementVNode("div", {
                                    class: _normalizeClass(['tabs-item', curTabRef.value === item.id ? 'tabs-item-active' : '']),
                                    key: item.id,
                                    onClick: function ($event) { return (changeTabs(item.id)); }
                                }, _toDisplayString(item.name), 11, _hoisted_18);
                            }), 64)),
                            _createElementVNode("div", {
                                class: "line",
                                style: _normalizeStyle({ left: curTabRef.value === 0 ? '80px' : '268px' })
                            }, null, 4)
                        ], 4),
                        (curTabRef.value === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", {
                                    innerHTML: state.value.description
                                }, null, 8, _hoisted_20)
                            ]))
                            : _createCommentVNode("", true),
                        (curTabRef.value === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.chapterList, function (item, index) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(['course-meun-tabs-item', chapterIdRef.value === item.id ? 'course-meun-tabs-item-active' : '']),
                                            onClick: function ($event) { return (changeChapter(index, item.id)); },
                                            key: item.id
                                        }, _toDisplayString(item.name), 11, _hoisted_23));
                                    }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMediaList.value, function (_) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "course-meun-item",
                                        key: _.id
                                    }, [
                                        _createElementVNode("div", {
                                            class: "cover",
                                            onClick: function ($event) { return (playCourse(_)); }
                                        }, [
                                            (_.payType === 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                    _createElementVNode("img", {
                                                        class: "lock",
                                                        src: require('@/pages/Course/assets/lock.png'),
                                                        alt: ""
                                                    }, null, 8, _hoisted_26)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: _.imgCover,
                                                alt: ""
                                            }, null, 8, _hoisted_27)
                                        ], 8, _hoisted_24),
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("div", _hoisted_30, _toDisplayString(_.name), 1),
                                                (_.payType !== 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "试看"))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                                (mediaType.value === 0 && _.video)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                        _createElementVNode("img", {
                                                            src: require('@/pages/Course/assets/time.png'),
                                                            alt: ""
                                                        }, null, 8, _hoisted_34),
                                                        _createElementVNode("div", null, _toDisplayString(getDuration(_.video.duration)), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createElementVNode("img", {
                                                        src: require('@/pages/Course/assets/play.png'),
                                                        alt: ""
                                                    }, null, 8, _hoisted_36),
                                                    _createElementVNode("div", null, _toDisplayString(_.readCountStr), 1)
                                                ]),
                                                _createElementVNode("div", {
                                                    class: "intro-item",
                                                    onClick: function ($event) { return (openTeachingMaterial(_)); }
                                                }, [
                                                    _createVNode(_component_van_icon, {
                                                        name: "description",
                                                        style: { "margin-right": "5px", "margin-top": "2px" }
                                                    }),
                                                    _hoisted_38
                                                ], 8, _hoisted_37)
                                            ])
                                        ])
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (currentVideo.value)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        style: _normalizeStyle({ zIndex: currentVideo.value ? 30 : 1 }),
                        src: currentVideo.value,
                        controls: "",
                        autoplay: "",
                        playsinline: ""
                    }, null, 12, _hoisted_39))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_40, [
                    _createVNode(OpenApp, {
                        appid: "wxf6e96c65ba6116d4",
                        text: "加入学习解锁全部课程",
                        extinfo: '/course/pipeline?course_id=' + _unref(skuId)
                    }, null, 8, ["extinfo"])
                ])
            ], 64));
        };
    }
});
